import { render } from "./EditProject.vue?vue&type=template&id=fa0a08f0&ts=true"
import script from "./EditProject.vue?vue&type=script&lang=ts"
export * from "./EditProject.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__